import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { Cotizacion } from "@/shared/types/cotizacion";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface SetCotizacionRequest{
    cotizacionData:Record<string, number>
}

export async function setCotizacion(request:SetCotizacionRequest):Promise<Cotizacion>{
    await sleep(1000);
    const response = await api.post("monetizacion/cotizacion", request);
    return response.data;
}

export function useSetCotizacionMutation(mutationConfig: MutationConfig<Cotizacion, SetCotizacionRequest> = {}){
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: setCotizacion,
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["monetizacion", "cotizacion"] });
        },
    })
}

export interface SetCotizacionMutationProps {
    mutationConfig?: MutationConfig<Cotizacion, SetCotizacionRequest>,
    children?: (mutationResult: MutationResult<Cotizacion, SetCotizacionRequest>) => ReactNode
}

export function SetCotizacionMutation({
    mutationConfig,
    children
}: SetCotizacionMutationProps) {
    const mutationResult = useSetCotizacionMutation(mutationConfig);
    return children && children(mutationResult);
}